module.exports = __webpack_public_path__ + "img/icon-play-menu.dd9d31c8.svg";